import I18n from "i18n-js";
import Notify from "./components/Notify";
import Navigation from "./components/Navigation";
import testLocalStorage from "./utils/testLocalStorage";
import initCartFabAttention from "./utils/initCartFabAttention";
import { init as initRating } from "./utils/Rating";
import CookieConsent from "./utils/CookieConsent";
import EaterLogin from "./utils/EaterLogin";

const client = {
  /**
   * Init global notification and navigation behavior.
   */
  initApp: function () {
    Notify.init();
    Navigation.init();
  },

  /**
   * Execute immediately without waiting for DOM.
   */
  executeImmediately: function () {
    // replace with empty function, so we don't log errors after unload
    window.onbeforeunload = function () {
      window.onerror = function (message, url, line_number) {};
    };
  },

  initMenuPage: function () {
    if (document.querySelector("[data-cart]") !== null) {
      import(/* webpackChunkName: "MenuPage" */ "./views/MenuPage").then(
        (mod) => mod["default"].init()
      );
    }
  },

  initCheckout: function () {
    if (document.querySelector(".ps-checkout")) {
      import(/* webpackChunkName: "Checkout" */ "./views/Checkout/init").then(
        (checkoutPage) =>
          checkoutPage.init(document.querySelector(".ps-checkout"))
      );
    }
  },

  initOrderInfo: function () {
    if (document.querySelector(".ps-order-info")) {
      import(
        /* webpackChunkName: "ThankYouPage" */ "./views/ThankYouPage/init"
      ).then((thankYouPage) =>
        thankYouPage.init(document.querySelector(".ps-order-info"))
      );
    }
  },

  initReservation: function () {
    if (document.getElementById("reservation")) {
      import(
        /* webpackChunkName: "Reservation" */ "./components/ReservationWrapper"
      ).then((mod) => mod["default"].init());
    }
  },
  initConsents: function () {
    if (document.getElementById("consents")) {
      import(
        /* webpackChunkName: "Consents" */ "./components/ConsentsWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  initNewsletter: function () {
    var location = Skubacz.configuration.view_name;

    // Own chunk because it imports from `restaumatic-client` lib -> avoid adding the lib into every-page js bundle
    if (document.getElementById("newsletter-confirmed")) {
      import(
        /* webpackChunkName: "NewsletterConfirmedTracking" */ "./components/NewsletterConfirmedTracking"
      ).then((mod) => mod["default"].init());
    }

    if (document.getElementById("newsletter-signup")) {
      import(
        /* webpackChunkName: "NewsletterSignup" */ "./components/NewsletterSignupWrapper"
      ).then((mod) => mod["default"].init(location));
    }
  },

  /**
   * Init cookie warning
   */
  initCookieConsent: function () {
    CookieConsent.init();
  },

  initEaterLogin: function () {
    if (Skubacz.configuration.feature_flags?.eater_login_enabled) {
      EaterLogin.init(I18n.currentLocale());
    }
  },

  initEaterAccount: function () {
    if (document.getElementById("eater-account")) {
      import(
        /* webpackChunkName: "EaterAccounts" */ "./components/EaterAccountWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  initDeliveryForm: () => {
    if (document.getElementById("delivery-checker")) {
      import(
        /* webpackChunkName: "DeliveryChecker" */ "./components/DeliveryCheckerWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  initOpenNowIndicators: function () {
    if (document.querySelector(".js-open-now-indicator")) {
      import(
        /* webpackChunkName: "OpenNowIndicator" */ "./components/OpenNowIndicatorWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  initRestaurantHoursWidgets: function () {
    if (document.querySelector(".js-restaurant-hours-widget")) {
      import(
        /* webpackChunkName: "RestaurantHoursWidget" */ "./components/RestaurantHoursWidgetWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  initSSR: () => {
    void import("./ssr.js");
  },

  initAgeVerification: function () {
    if (Skubacz.configuration.feature_flags?.enable_age_verification) {
      import(
        /* webpackChunkName: "AgeVerificationModal" */ "./utils/AgeVerification"
      ).then((mod) => mod.init());
    }
  },

  initComponentPreview: function () {
    if (document.getElementById("js-component-preview-container") !== null) {
      import(
        /* webpackChunkName: "ComponentPreview" */ "./views/ComponentPreview/init"
      ).then((mod) => mod.init());
    }
  },
};

client.executeImmediately();

function init() {
  testLocalStorage();
  client.initCookieConsent();
  client.initAgeVerification();
  client.initApp();
  initRating();
  client.initMenuPage();
  client.initCheckout();
  client.initOrderInfo();
  client.initReservation();
  client.initConsents();
  client.initNewsletter();
  client.initEaterLogin();
  client.initEaterAccount();
  client.initDeliveryForm();
  client.initOpenNowIndicators();
  client.initRestaurantHoursWidgets();
  initCartFabAttention();
  client.initComponentPreview();
  client.initSSR();
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.__pageInitHook__) {
    window.__pageInitHook__().then(init);
  } else {
    init();
  }
});
